module.exports = __webpack_public_path__ + "font/fd850139b4cf133f3a26fcc195cba595.otf";